<template>
  <div @click="goto">
    <svg-icon icon-class="bulb-on"  />
    <span class="pl-5" style="color: #007bff" >如何使用</span>
  </div>
</template>

<script setup>
// 从环境变量获取帮助文档URL，如果未配置则使用默认值
const url = ref(import.meta.env.VITE_APP_HELP_URL || 'https://www.lamtau.com/howtouse/');

function goto() {
  window.open(url.value)
}
</script>
